<script setup lang="ts">
useHead({
	link: [{
		rel: "icon", type: "image/x-icon", href: "/favicon.ico"
	}]
});
</script>

<template>
	<NuxtLayout>
		<NuxtPage />
	</NuxtLayout>
	<CommonAlertStack />
	<NuxtLoadingIndicator color="#7C3AED" />
</template>

<style>
.nuxt-icon svg {
	margin-bottom: 0;
}
</style>
